// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-box[data-v-1ed9dbea] {\n  padding: 10px 20px;\n}\n.button-box .el-button[data-v-1ed9dbea] {\n  float: right;\n}\n.el-tag--mini[data-v-1ed9dbea] {\n  margin-left: 5px;\n}\n.warning[data-v-1ed9dbea] {\n  color: #dc143c;\n}", ""]);
// Exports
module.exports = exports;
